/*
  Fixes Hulk Wishlist links that use href="javascript:void(0)".
  This keeps the wishlist app classes/data attributes intact, but gives crawlers
  and no-JS users a real fallback link.
*/
(function () {
  var wishlistSelector = [
    'a.icon-wishlist-heart-empty[href^="javascript:"]',
    'a.wishlist-btn[href^="javascript:"]',
    'a[data-wishlist][href^="javascript:"]'
  ].join(',');

  function findProductHref(link) {
    var scope = link.closest('.product-block, .product-list-item, .product-card, .product-item, [data-product-id], li, article') || link.parentElement;
    var productLink = scope ? scope.querySelector('a[href*="/products/"]:not(.wishlist-btn):not([data-wishlist]):not(.icon-wishlist-heart-empty)') : null;

    return productLink && productLink.href ? productLink.href : '/apps/advanced-wishlist';
  }

  function normalizeWishlistLinks(root) {
    var context = root && root.querySelectorAll ? root : document;

    context.querySelectorAll(wishlistSelector).forEach(function (link) {
      link.setAttribute('href', findProductHref(link));
      link.setAttribute('role', 'button');

      if (!link.getAttribute('aria-label')) {
        link.setAttribute('aria-label', 'Add to wishlist');
      }
    });
  }

  function start() {
    var scheduled = false;

    normalizeWishlistLinks(document);

    new MutationObserver(function () {
      if (scheduled) return;

      scheduled = true;
      window.setTimeout(function () {
        scheduled = false;
        normalizeWishlistLinks(document);
      }, 50);
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href', 'class']
    });

    [500, 1500, 3000, 7000].forEach(function (delay) {
      window.setTimeout(function () {
        normalizeWishlistLinks(document);
      }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());
